import { IStateApps } from '@models/state-apps';
import { IStateServers } from '@models/state-servers';
import { TSupportedLanguages } from '@models/supported-languages';
import { Item } from '@visual/search-filter-popup';

/*
  G5_各種情報_VIP
  ==============
  キーワード
  ID
*/

export function getFields(
  lang: TSupportedLanguages,
  apps: IStateApps,
  servers: IStateServers,
): Item[] {
  return [];
}
